export const isPro = (subscription: { current_period_end: number }) =>
  subscription && subscription.current_period_end < new Date().getTime();

export const paymentFailed = (subscription: {
  current_period_end: number;
  status: "active" | "past_due" | "unpaid";
}) =>
  subscription &&
  (subscription.status === "past_due" || subscription.status === "unpaid");
